import i18next from 'i18next'
import memoize from 'lodash/memoize'

// Need to have a memoize function on generators to prevent rerenders in redux-form
export const numberMinMax = (minValue: number, maxValue?: number) => (value: string) => {
  const parsedValue = Number.parseFloat(value) // TODO: this breaks in combination with normalizeMaxDecimals replaces , by . and this
  // ignores . on dutch locale

  if (parsedValue >= minValue && (maxValue === undefined || parsedValue <= maxValue)) {
    return undefined // no error
  }

  return maxValue === undefined
    ? i18next.t('global.value_out_of_bounds_min', { value: minValue })
    : i18next.t('global.value_out_of_bounds_min_max', { minValue, maxValue })
}

export const numberMinMaxCheck = memoize(numberMinMax, (min, max) => `${min}, ${max}`)
